<template>
  <ModalVue
      :fields="[
      { name: 'firstname', type: 'text', tag: 'input', placeholder: 'imię', req: true, value: firstName, label: 'imię' },
      { name: 'lastname', type: 'text', tag: 'input', placeholder: 'nazwisko', req: true, value: lastName, label: 'nazwisko' },
      { name: 'businessName', type: 'text', tag: 'input', placeholder: 'nazwa działalności', req: true, minlength: 3, maxlength: 50, value: name, label: 'nazwa działalności' },
      { name: 'phone', type: 'tel', tag: 'input', placeholder: 'numer telefonu', req: true, htmlPattern: '[0-9]{9}', value: phone, label: 'numer telefonu' },
      { name: 'phone2', type: 'tel', tag: 'input', placeholder: 'numer telefonu 2', req: false, htmlPattern: '[0-9]{9}', value: phone2, label: 'numer telefonu 2' },
      { name: 'state', tag: 'select', options: states, value: user_state_id, label: 'województwo' },
      { name: 'address', type: 'text', tag: 'input', placeholder: 'adres', req: false, value: address, label: 'adres' },
      { name: 'category', tag: 'select', options: categories, value: user_category_id, label: 'kategoria' },
      { name: 'nip', type: 'text', tag: 'input', placeholder: 'nip', req: false, value: nip, label: 'nip' }
    ]"
      title="edytuj dane"
      button-text="zatwierdź"
      :isVisible="isModalVisible"
      @closeModal="() => { isModalVisible = false; }"
      @sendData="(data) => editUser(data)"
  />

  <ModalVue
      :fields="[
      { name: 'photo', type: 'file', tag: 'input', req: true }
    ]"
      title="prześlij zdjęcie"
      button-text="wyślij"
      :is-visible="isPhotoModalVisible"
      @closeModal="() => { isPhotoModalVisible = false; }"
      @sendData="(data) => sendPhoto(data)"
  />

  <ModalVue
      :fields="[
      { name: 'oldpassword', type: 'password', tag: 'input', req: true, placeholder: 'obecne hasło' },
      { name: 'newpassword', type: 'password', tag: 'input', req: true, placeholder: 'nowe hasło', minlength: 8 },
      { name: 'repeatpassword', type: 'password', tag: 'input', req: true, placeholder: 'powtórz nowe hasło', minlength: 8 }
    ]"
      title="zmień hasło"
      :is-visible="isPassModalVisible"
      button-text="zmień"
      @closeModal="() => { isPassModalVisible = false; }"
      @sendData="(data) => changePass(data)"
  />

  <ModalVue
      :fields="[
      { name: 'merchantId', type: 'text', tag: 'input', req: true, placeholder: 'Klucz do zamówień', value: merchantId },
      { name: 'reportsKey', type: 'text', tag: 'input', req: true, placeholder: 'Klucz do raportów', value: reportsKey },
      { name: 'crc', type: 'text', tag: 'input', req: true, placeholder: 'Klucz do CRC', value: crc }
    ]"
      title="Dane do bramki płatności"
      :is-visible="isAPIkeysModalVisible"
      button-text="zmień"
      @closeModal="() => { isAPIkeysModalVisible = false; }"
      @sendData="(data) => addAPIkeys(data)"
  />

  <div v-if="currentUser && currentUser.role_id === 2" class="user-data-page">
    <div class="page-header">
      <h1>Twoje dane</h1>
      <div class="header-actions">
        <button class="btn-outline" @click="isModalVisible = true">Edytuj profil</button>
        <button class="btn-primary" @click="isPassModalVisible = true">Zmień hasło</button>
      </div>
    </div>

    <div
        class="alert-card"
        v-if="!description || !short_description || !address || !state || !nip || !krs || !pzw || (!merchantId || !crc || !reportsKey) || !terms_and_conditions_url || !privacy_policy_url"
    >
      <h3>Uzupełnij dane profilu:</h3>
      <ul>
        <li v-if="!description || !short_description">Opisy działalności</li>
        <li v-if="!address">Adres gabinetu</li>
        <li v-if="!state">Województwo</li>
        <li v-if="!nip">NIP</li>
        <li v-if="!krs">KRS</li>
        <li v-if="!pzw">Numer prawa wykonywania zawodu</li>
        <li v-if="!merchantId || !crc || !reportsKey">Dane do bramki płatności</li>
        <li v-if="!terms_and_conditions_url">Regulamin (PDF)</li>
        <li v-if="!privacy_policy_url">Polityka prywatności (PDF)</li>
      </ul>
    </div>

    <div class="layout">
      <section class="section-card profile-card">
        <div class="profile-top-actions">
          <button class="btn-icon" @click="isModalVisible = true" title="Edytuj">
            <img src="@/assets/icons/pencil-square.svg" alt="edytuj">
          </button>
        </div>

        <button
            class="avatar-btn"
            @click="() => {
            if (!userPhotoUrl) {
              isPhotoModalVisible = true
            } else {
              removePhoto()
            }
          }"
            :title="userPhotoUrl ? 'Usuń zdjęcie' : 'Dodaj zdjęcie'"
        >
          <img class="avatar" :src="userPhotoUrl ? userPhotoUrl : getImageUrl()" alt="">
          <span class="avatar-overlay">
            <img v-if="!userPhotoUrl" src="@/assets/icons/pencil-square.svg" alt="dodaj">
            <img v-else src="@/assets/icons/trash.svg" alt="usuń">
          </span>
        </button>

        <h2 class="profile-name">{{ firstName }} {{ lastName }}</h2>
        <p class="profile-email">{{ email }}</p>

        <div class="info-list">
          <p :class="{ muted: !name }">{{ name || 'brak nazwy biznesu' }}</p>
          <p :class="{ muted: !address }">{{ address || 'brak adresu' }}</p>
          <p :class="{ muted: !phone }">tel: {{ phone || 'brak' }}</p>
          <p :class="{ muted: !phone2 }">tel 2: {{ phone2 || 'brak' }}</p>
          <p :class="{ muted: !category }">{{ category ? category.name : 'brak kategorii' }}</p>
          <p :class="{ muted: !state }">{{ state ? state.name : 'brak województwa' }}</p>
          <p :class="{ muted: !nip }">NIP: {{ nip || 'brak' }}</p>
        </div>

        <div class="card-actions">
          <button class="btn-primary" @click="isPassModalVisible = true">Zmień hasło</button>
          <button class="btn-outline" @click="$router.push(`/browse/user/${currentUser.id}`)">Twoja wizytówka</button>
          <button class="btn-outline" @click="isAPIkeysModalVisible = true">Bramka płatności</button>
          <button class="btn-danger" @click="confirmDelete = true">Usuń konto</button>
        </div>

        <div class="confirm-delete" v-if="confirmDelete">
          <span>Czy na pewno?</span>
          <div>
            <button class="btn-danger" @click="deleteAccount">Tak</button>
            <button class="btn-outline" @click="confirmDelete = false">Nie</button>
          </div>
        </div>
      </section>

      <section class="section-card forms-card">
        <form @submit="(e) => sendDescriptions(e)">
          <h3>Opisy działalności</h3>
          <label for="shortDescription">Krótki opis</label>
          <textarea id="shortDescription" v-model="short_description" maxlength="350" minlength="20"></textarea>

          <label for="description">Opis działalności</label>
          <textarea id="description" v-model="description" maxlength="3000" minlength="80"></textarea>
          <button type="submit" class="btn-primary">Zapisz opisy</button>
        </form>

        <form @submit.prevent="editKrs">
          <h3>Dane rejestrowe</h3>
          <label for="krs">KRS</label>
          <input type="text" id="krs" v-model="krs" pattern="[0-9]*$" minlength="9" maxlength="14">
          <button type="submit" class="btn-primary">Zapisz KRS</button>
        </form>

        <form @submit.prevent="editRegon">
          <label for="regon">REGON</label>
          <input type="text" id="regon" v-model="regon" pattern="^[0-9]{9}">
          <button type="submit" class="btn-primary">Zapisz REGON</button>
        </form>

        <form @submit.prevent="editPzw">
          <label for="pzw">Numer PZW (jeśli obowiązuje)</label>
          <input type="text" id="pzw" v-model="pzw" pattern="[0-9]{7}">
          <button type="submit" class="btn-primary">Zapisz PZW</button>
        </form>

        <form @submit.prevent="editFv">
          <h3>Dane do faktury</h3>
          <input type="text" id="fvNip" v-model="fv.nip" placeholder="NIP">
          <input type="text" id="fvAddress" v-model="fv.address" placeholder="Adres">
          <input type="text" id="fvName" v-model="fv.name" placeholder="Nazwa działalności">
          <button type="submit" class="btn-primary">Zapisz dane FV</button>
        </form>

        <form @submit.prevent="sendDocuments">
          <h3>Dokumenty PDF</h3>
          <p class="hint">
            Aby pobierać zaliczki, dodaj regulamin i politykę prywatności (PDF).
          </p>

          <label v-if="!terms_and_conditions_url" for="termsAndConditions">Regulamin</label>
          <a target="blank" :href="terms_and_conditions_url" v-if="terms_and_conditions_url">Podgląd regulaminu</a>
          <div class="file-row">
            <span>{{ terms_and_conditions_url ? 'Zmień dokument:' : 'Dodaj dokument:' }}</span>
            <input @input="(e) => loadTermsAndConditions(e)" type="file" id="termsAndConditions" accept=".pdf">
          </div>

          <label v-if="!privacy_policy_url" for="privacyPolicy">Polityka prywatności</label>
          <a target="blank" :href="privacy_policy_url" v-if="privacy_policy_url">Podgląd polityki prywatności</a>
          <div class="file-row">
            <span>{{ privacy_policy_url ? 'Zmień dokument:' : 'Dodaj dokument:' }}</span>
            <input @input="(e) => loadPrivacyPolicy(e)" type="file" id="privacyPolicy" accept=".pdf">
          </div>

          <button v-if="!privacy_policy_url || !terms_and_conditions_url" type="submit" class="btn-primary">Wyślij</button>
        </form>
      </section>
    </div>
  </div>

  <div v-else class="fallback">
    <h2>Błąd wczytywania. Spróbuj ponownie.</h2>
  </div>
</template>

<script>
import ModalVue from '@/components/Modal.vue';
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizProfileUserData',
  components: { ModalVue },
  data() {
    return {
      user_state_id: 0,
      user_category_id: 0,
      userPhotoUrl: '',
      userPhotoId: '',
      firstName: '',
      lastName: '',
      email: '',
      isModalVisible: false,
      isPhotoModalVisible: false,
      isPassModalVisible: false,
      name: '',
      address: '',
      description: '',
      short_description: '',
      phone: '',
      category: null,
      state: null,
      states: [],
      categories: [],
      nip: '',
      krs: '',
      regon: '',
      terms_and_conditions_url: '',
      privacy_policy_url: '',
      terms_and_conditions: null,
      privacy_policy: null,
      confirmDelete: false,
      merchantId: null,
      reportsKey: null,
      crc: null,
      fv: {
        nip: '',
        address: '',
        name: ''
      },
      pzw: null,
      phone2: null,
      isAPIkeysModalVisible: false
    };
  },
  setup() {
    useMeta({ title: 'twoje dane' });
    return {
      authStore: useAuthStore(),
      appStore: useAppStore()
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  created() {
    this.getUserData();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }
  },
  methods: {
    getImageUrl() {
      return new URL(`../../assets/photo-placeholder.png`, import.meta.url).href;
    },
    getUserData() {
      axios.get(`/User/${this.currentUser.id}`).then(res => {
        this.firstName = res.data.firstname;
        this.lastName = res.data.lastname;
        this.email = res.data.email;
        this.name = res.data.name;
        this.address = res.data.address;
        this.description = res.data.description;
        this.short_description = res.data.short_description;
        this.phone = res.data.phone;
        this.category = res.data.category;
        this.state = res.data.state ? res.data.state : { name: null, id: null };
        this.user_category_id = res.data.category_id;
        this.user_state_id = res.data.state_id;
        this.nip = res.data.nip;
        this.krs = res.data.krs;
        this.regon = res.data.regon;
        this.terms_and_conditions_url = res.data.terms_and_conditions_url;
        this.privacy_policy_url = res.data.privacy_policy_url;
        this.merchantId = res.data.merchantId;
        this.reportsKey = res.data.reportsKey;
        this.crc = res.data.crc;
        if (res.data.fv) {
          if (res.data.fv.nip) this.fv.nip = res.data.fv.nip;
          if (res.data.fv.address) this.fv.address = res.data.fv.address;
          if (res.data.fv.name) this.fv.name = res.data.fv.name;
        }
        this.pzw = res.data.pzw_number;
        this.phone2 = res.data.phone_2;
      });

      axios.get(`/UserImage/${this.currentUser.id}`).then(res => {
        if (res.data.length > 0) {
          this.userPhotoUrl = res.data[0].photo_url;
          this.userPhotoId = res.data[0].id;
        }
      });

      axios.get('/State').then(res => {
        this.states = [];
        res.data.forEach(item => {
          this.states.push({ name: item.name, value: `${item.id}` });
        });
      });

      axios.get('/Categories').then(res => {
        this.categories = [];
        res.data.forEach(item => {
          this.categories.push({ name: item.name, value: `${item.id}` });
        });
      });
    },
    editUser(data) {
      axios.post(`/UserProfile`, {
        id: this.currentUser.id,
        firstname: data.firstname,
        lastname: data.lastname,
        email: this.email,
        name: data.businessName,
        phone: data.phone,
        category_id: data.category,
        state_id: data.state,
        address: data.address,
        nip: data.nip,
        phone_2: data.phone2,
        description: this.description,
        short_description: this.short_description,
        krs: this.krs,
        regon: this.regon,
        pzw_number: this.pzw,
        merchantId: this.merchantId,
        reportsKey: this.reportsKey,
        crc: this.crc
      }, authHeader()).then(() => {
        this.appStore.setIsSuccess('Pomyślnie zaktualizowano dane');
        this.getUserData();
      }).catch(error => {
        if (error.response?.status !== 422) {
          this.appStore.setIsAlert('Wystąpił błąd podczas aktualizacji danych');
        }
      });
    },
    sendPhoto(data) {
      axios.post('/UserImage', {
        user_id: this.currentUser.id,
        photo: data.photo
      }, {
        headers: {
          ['Content-Type']: 'multipart/form-data'
        }
      }).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie dodano zdjęcie');
          this.userPhotoUrl = URL.createObjectURL(data.photo);
        }
      });
    },
    removePhoto() {
      axios.delete(`/UserImage/${this.userPhotoId}`, authHeader).then((res) => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto zdjęcie');
          this.userPhotoUrl = '';
        }
      }).catch(() => {
        setTimeout(() => {
          location.reload();
        }, 500);
      });
    },
    loadTermsAndConditions(event) {
      this.terms_and_conditions = event.target.files[0];
      axios.post('/UserPdf', {
        user_id: this.currentUser.id,
        terms_and_conditions: this.terms_and_conditions
      }, {
        headers: {
          ['Content-Type']: 'multipart/form-data'
        }
      }).then(() => {
        this.appStore.setIsSuccess('Pomyślnie wgrano dokument');
        this.terms_and_conditions_url = URL.createObjectURL(this.terms_and_conditions);
      }).catch(() => {});
    },
    loadPrivacyPolicy(event) {
      this.privacy_policy = event.target.files[0];
      axios.post('/UserPdf', {
        user_id: this.currentUser.id,
        privacy_policy: this.privacy_policy
      }, {
        headers: {
          ['Content-Type']: 'multipart/form-data'
        }
      }).then(() => {
        this.appStore.setIsSuccess('Pomyślnie wgrano dokument');
        this.privacy_policy_url = URL.createObjectURL(this.privacy_policy);
      }).catch(() => {});
    },
    sendDescriptions(e) {
      e.preventDefault();
      axios.post(`/UserProfile`, {
        id: this.currentUser.id,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        name: this.name ?? this.firstName + ' ' + this.lastName,
        phone: this.phone,
        category_id: this.category.id,
        state_id: this.state.id,
        address: this.address,
        nip: this.nip,
        phone_2: this.phone2,
        description: this.description,
        short_description: this.short_description,
        krs: this.krs,
        regon: this.regon,
        pzw_number: this.pzw,
        merchantId: this.merchantId,
        reportsKey: this.reportsKey,
        crc: this.crc
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano opisy');
        }
      });
    },
    changePass(data) {
      axios.post('/ChangePassword', {
        oldpassword: data.oldpassword,
        newpassword: data.newpassword,
        repeatpassword: data.repeatpassword
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano hasło');
          window.location.href = '/';
        }
      }).catch(() => {});
    },
    editKrs() {
      this.saveProfileAndNotify('Pomyślnie zaktualizowano numer KRS');
    },
    editRegon() {
      this.saveProfileAndNotify('Pomyślnie zaktualizowano numer REGON');
    },
    editPzw() {
      this.saveProfileAndNotify('Pomyślnie zaktualizowano numer PZW');
    },
    editFv() {
      axios.post('/UserProfile', {
        id: this.currentUser.id,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        name: this.name,
        phone: this.phone,
        category_id: this.category.id,
        state_id: this.state.id,
        address: this.address,
        nip: this.nip,
        phone_2: this.phone2,
        description: this.description,
        short_description: this.short_description,
        krs: this.krs,
        regon: this.regon,
        pzw_number: this.pzw,
        fv: {
          nip: this.fv.nip,
          address: this.fv.address,
          name: this.fv.name
        },
        merchantId: this.merchantId,
        reportsKey: this.reportsKey,
        crc: this.crc
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano dane do faktury');
        }
      });
    },
    saveProfileAndNotify(message) {
      axios.post('/UserProfile', {
        id: this.currentUser.id,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        name: this.name,
        phone: this.phone,
        category_id: this.category.id,
        state_id: this.state.id,
        address: this.address,
        nip: this.nip,
        phone_2: this.phone2,
        description: this.description,
        short_description: this.short_description,
        krs: this.krs,
        regon: this.regon,
        pzw_number: this.pzw,
        merchantId: this.merchantId,
        reportsKey: this.reportsKey,
        crc: this.crc
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess(message);
        }
      });
    },
    sendDocuments() {
      this.appStore.setIsSuccess('Dokumenty zostały przesłane');
    },
    deleteAccount() {
      axios.delete(`/User/${this.currentUser.id}`, authHeader()).then(() => {
        this.$router.push('/');
        localStorage.removeItem('userm2VET');
        window.location.reload();
      });
    },
    addAPIkeys(data) {
      axios.post('/UserProfile', {
        id: this.currentUser.id,
        firstname: this.firstName,
        lastname: this.lastName,
        email: this.email,
        name: this.name,
        phone: this.phone,
        category_id: this.category.id,
        state_id: this.state.id,
        address: this.address,
        nip: this.nip,
        phone_2: this.phone2,
        description: this.description,
        short_description: this.short_description,
        krs: this.krs,
        regon: this.regon,
        pzw_number: this.pzw,
        merchantId: data.merchantId,
        reportsKey: data.reportsKey,
        crc: data.crc
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano dane do bramki płatności');
          this.crc = data.crc;
          this.merchantId = data.merchantId;
          this.reportsKey = data.reportsKey;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.user-data-page {
  background: #ffffff;
  min-height: 100vh;
  padding: 24px 16px 32px;
  color: #1f2937;
}

.page-header {
  max-width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 14px;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.alert-card {
  max-width: 1168px;
  margin: 0 auto 20px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 12px;
  padding: 14px 16px;
}

.alert-card h3 {
  margin: 0 0 8px;
  color: #9a3412;
  font-size: 1.6rem;
}

.alert-card ul {
  margin: 0;
  padding-left: 18px;
  color: #7c2d12;
  font-size: 1.35rem;
  line-height: 1.5;
}

.layout {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.section-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
  box-sizing: border-box;
}

.profile-card {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.profile-top-actions {
  display: flex;
  justify-content: flex-end;
}

.avatar-btn {
  border: none;
  background: none;
  cursor: pointer;
  align-self: center;
  width: 120px;
  height: 120px;
  position: relative;
  border-radius: 999px;
  overflow: hidden;
}

.avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 999px;
  border: 2px solid #e5e7eb;
}

.avatar-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.35);
  opacity: 0;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-overlay img {
  width: 20px;
  height: 20px;
}

.avatar-btn:hover .avatar-overlay {
  opacity: 1;
}

.profile-name {
  margin: 6px 0 0;
  text-align: center;
  font-size: 1.9rem;
}

.profile-email {
  margin: 0;
  text-align: center;
  color: #6b7280;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-list p {
  margin: 0;
  font-size: 1.4rem;
  color: #374151;
  text-align: center;
}

.info-list p.muted {
  color: #9ca3af;
}

.card-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.confirm-delete {
  margin-top: 8px;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.confirm-delete div {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.forms-card {
  flex: 1 1 0;
  min-width: 0;
}

.forms-card form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.forms-card form:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.forms-card h3 {
  margin: 0 0 4px;
  font-size: 1.7rem;
}

.forms-card label,
.forms-card .hint {
  font-size: 1.35rem;
  color: #374151;
}

.forms-card .hint {
  margin: 0;
  color: #6b7280;
}

.forms-card textarea,
.forms-card input:not([type='file']) {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
  transition: 0.2s;
}

.forms-card textarea {
  min-height: 100px;
  resize: vertical;
}

.forms-card textarea:focus,
.forms-card input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.file-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.forms-card a {
  color: #2563eb;
  text-decoration: none;
  font-size: 1.35rem;
}
.forms-card a:hover {
  text-decoration: underline;
}

.btn-primary,
.btn-outline,
.btn-danger,
.btn-icon {
  border-radius: 8px;
  font-size: 1.35rem;
  cursor: pointer;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  padding: 10px 14px;
  font-weight: 600;
}
.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  padding: 10px 14px;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-danger {
  background: #dc3545;
  color: #fff;
  border: none;
  padding: 10px 14px;
}
.btn-danger:hover {
  background: #b91c1c;
}

.btn-icon {
  background: none;
  border: none;
  padding: 6px;
}
.btn-icon img {
  width: 18px;
  height: 18px;
}

.fallback {
  padding: 24px;
  text-align: center;
}

@media (max-width: 980px) {
  .layout {
    flex-direction: column;
  }

  .profile-card {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .user-data-page {
    padding: 16px 12px 24px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .btn-primary,
  .btn-outline,
  .btn-danger {
    width: 100%;
    text-align: center;
  }

  .confirm-delete div {
    width: 100%;
  }

  .confirm-delete div button {
    flex: 1;
  }
}
</style>